import { useEffect, useState } from "react";
import { Link } from "react-router";
import { ErrorNotice, useAction } from "../components/ui";
import { api, type PoolMembership } from "../lib/api";
import { AddedNotice, AddToPool } from "./AddToPool";

/** The talent pools a candidate is in, with a way to add them to another. */
export function CandidatePools({ candidateId, name, erased }: { candidateId: string; name: string; erased: boolean }) {
  const [pools, setPools] = useState<PoolMembership[] | null>(null);
  const [adding, setAdding] = useState(false);
  const [added, setAdded] = useState<{ pool: { id: string; name: string }; message: string } | null>(null);
  const load = useAction();

  const refresh = async () => setPools((await api.candidatePools(candidateId)).pools);
  useEffect(() => {
    void load.run(refresh);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidateId]);

  return (
    <section className="section" aria-labelledby="cand-pools-h">
      <div className="section-head">
        <h2 id="cand-pools-h" className="label">
          Talent pools
        </h2>
        {!erased && !adding && (
          <button type="button" className="link-btn" onClick={() => setAdding(true)}>
            + Add to a pool
          </button>
        )}
      </div>
      <AddedNotice added={added} />
      {adding && (
        <AddToPool
          candidateIds={[candidateId]}
          exclude={pools?.map((p) => p.poolId)}
          onCancel={() => setAdding(false)}
          onAdded={(pool) => {
            setAdding(false);
            setAdded({ pool, message: `Added ${name} to ${pool.name}.` });
            void load.run(refresh);
          }}
        />
      )}
      <ErrorNotice error={load.error} />
      {pools && pools.length > 0 && (
        <ul className="pool-chips">
          {pools.map((p) => (
            <li key={p.poolId}>
              <Link to={`/pools/${p.poolId}`}>{p.name}</Link>
              {p.note && <span className="secondary">{p.note}</span>}
            </li>
          ))}
        </ul>
      )}
      {pools && pools.length === 0 && !adding && <p className="empty-line">Not in any pools.</p>}
    </section>
  );
}
